<!-- <h1>New Data Chart</h1>
<div #chart style="width: 100%; height: 400px;"></div> -->



<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Heat Pump Dashboard</title>
  <link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
</head>
<body class="text-white">

<app-alarm-dashboard class="alarm-pop-up" [showAlarmPopup]="showAlarmPopup"  *ngIf="showAlarmPopup && !showActionPopUp" (closeModal) = "closeModal()" [deviceDetails]="deviceDetails"></app-alarm-dashboard>

<app-action-history-dashboard *ngIf="showActionPopUp" class="action-history-pop-up" (closeModal)="closeModal()" [controllerDetails]="controllerDetails"></app-action-history-dashboard>
 <app-customer-card *ngIf="showCustomerPopUp" class="customer-card" (closeModal)="closeModal()"></app-customer-card>



  <div class="container-fluid">
    <div class="row gx-0">
      <div class="col-lg-12 d-flex">
  

  <div class="side-menu">
    <app-side-bar></app-side-bar>
  </div>


<div class="right-side">
  <!-- Header -->
  
    <div class="profile-card">
      <img [src]="profileImage" alt="User" class="profile-pic" (click)="onProfileTap()"/>
      <div class="profile-info">
        <h2 class="profile-name">{{fullName}}</h2>
        <p class="profile-email">{{userName}}</p>
      </div>
    </div>

<!-- USER PROFILE HEADER -->
<!-- <div class="profile-card" -->


  <!-- Controls -->
    <div class="device-info-head flex items-center gap-2">
      <a class="device-home-icon"><img src="assets/img/device-home.svg" alt="dashboard" (click)="homeScreen()"/></a>
      <h1 class="text-2xl fw-light pe-3">{{device_id}}</h1>

        <div class="metric-select" [ngClass]="getSelectedMetricClass()">
        <select [(ngModel)]="selectedMetric" (change)="onMetricChange(true)" class="">
            <option *ngFor="let metric of availableMetrics" [ngValue]="metric" class="telemetry-options">
              {{ metric.label }}
            </option>
          </select>
          </div>

      <button class="mx-2" (click)="onActionHistoryTap()">
         <span class="text-xl"> <img 
          src="assets/img/action-history-icon.svg" 
          alt="Danger" 
          
        />
    </span>
      </button>
      <button (click)="onNotificationClick()">
        <span class="text-xl"> <img 
          src="assets/img/bell-icon.svg" 
          alt="Danger" 
          
        />
    </span>
      </button>
    </div>


    <div>

    </div>
 

  <!-- Tabs -->
<div class="controller-container">


  <div class="flex gap-4 flex-nowrap">
   
      <button class="controller-container history-telem text-white" (click)="getTelemtryDetails()" [class.telemetery-selected] = "!historyScreenBool">
        <div  class="el"></div>
        <div  class="lef"></div>
        Telemetry</button>
      <button class="controller-container text-white history-telem" (click)="historyScreen()" [class.history-selected] = "historyScreenBool">
        <div  class="el"></div>
        <div  class="lef"></div>
        History</button>
 
  </div>

  <!-- Chart Card -->
  <div class="card-bg rounded-2xl p-6  -mt-2 relative z-0 chart-card chart-class"  [ngClass]="{ 'gauge-style': !historyScreenBool,'card-style':historyScreenBool,'chart-class':!historyScreenBool }">
    <div *ngIf="!historyScreenBool;else history" >
      <div [ngSwitch]="telemetryView"  [ngClass]="{ 'gpio-style': telemetryView}" >
        <ng-container *ngIf="spinner; else showGauge;">
                                  <div
                          class="loader-container"
                        >
                          <span class="loader"></span>
                        </div>
        </ng-container>

        <ng-template #showGauge>
          <div *ngSwitchCase="true" id="chart" class="chart" class="d-flex justify-center align-items-center" [ngClass]="{ 'chart': !historyScreenBool }">
          </div>
          </ng-template>
          
      


        
        <div id="telemetery-without-gauge" *ngSwitchCase="false">
          <ng-container *ngIf="spinner; else showImage">
          <div class="loader"></div>
          </ng-container>
            <ng-template #showImage>
            <img  class="telem-img"  [src]="telemetryDetails?.img"  [ngClass]="getDeviceClass()"/>
            <div ><span *ngIf="selectedMetric?.value != 'pool_cover_status'">{{telemetryDetails?.value}}</span> {{telemetryDetails?.unit}}</div> <hr>
          </ng-template>
      </div>
      
    </div>

  </div>
  <ng-template #history>
    
    <div class="flex justify-end p-2">
      <div *ngIf="deviceSpecificDatepicker ;else gpio" class="date-filter">
     
        <mat-date-range-input [rangePicker]="datepicker" #dateRangeInput  [min]="previousDate" [max]="maxDate" >  
          <input matStartDate [min]="previousDate" [(ngModel)]="planModel" name="datepicker" />
          <input matEndDate  />
          
        </mat-date-range-input>
        <mat-date-range-picker #datepicker [startAt]="maxDate">
          <mat-date-range-picker-actions>
            <button matButton matDateRangePickerCancel>Cancel</button>
            <button matButton="elevated" matDateRangePickerApply (click)="onApplyClick(dateRangeInput,undefined)">Apply</button>
          </mat-date-range-picker-actions>
        </mat-date-range-picker>
  </div>
  <ng-template #gpio>
    <div class="date-filter">
      <input matInput [matDatepicker]="datepicker" #dateRange = 'matDatepickerInput' [min]="previousDate" [max]="maxDate" [(ngModel)]="planModel" name="datepicker" />
      <mat-datepicker #datepicker  class="date-picker-gpio" backdropClass="backdrop-disabled" >
        <mat-datepicker-actions>
          <button matButton matDatepickerCancel>Cancel</button>
          <button matButton="elevated" matDatepickerApply (click)="onApplyClick(undefined,dateRange)">Apply</button>
        </mat-datepicker-actions>
      </mat-datepicker>
    </div>
  </ng-template>
      <mat-form-field appearance="fill" class="custom-select">
        <mat-select [(value)]="selectedDateRange" >
          <mat-option *ngFor="let option of availableDateRanges" [value]="option" (click) = "onMetricChange(false)" class="options">{{ option.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div id="y-axis"></div>
    <div id="chart" class="h-auto overflow-x-auto border-gray-300 p-2 history-div">
      
     
      <div *ngIf="noData" class="text-center mt-4 text-sm text-white-300 uppercase" style="margin-top: 50px;">
        No history to plot
      </div>

    </div>
   
    <div id = "chart" class="w-full h-auto flex justify-center"></div>
  </ng-template>


    <div class="text-center mt-4  text-sm text-gray-300 uppercase" *ngIf="!telemetryView && getTelemetryNull ">
      {{ selectedMetric?.label }}
    </div>
  </div>


  </div>


  </div>
  </div>
  </div>
  </div>





  </body>
</html>
